import Inter_Regular from "./Inter-Regular.js";
import Inter_SemiBold from "./Inter-SemiBold.js";
import Inter_Light from "./Inter-Light.js";
import Inter_Medium from "./Inter-Medium.js";
import VKSansText_Regular from "./VKSansText-Regular.js";
const fonts = `
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: 
      local('Inter Regular'), 
      local('Inter-Regular'), 
      url(${Inter_Regular}) format('woff2');
    unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: 
      local('Inter Regular'), 
      local('Inter-Regular'), 
      url(${Inter_Regular}) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'VKSans';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: 
      local('VKSans Regular'), 
      local('VKSans-Regular'), 
      url(${VKSansText_Regular}) format('woff2');
    unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }
  @font-face {
    font-family: 'VKSans';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: 
      local('VKSans Regular'), 
      local('VKSans-Regular'), 
      url(${VKSansText_Regular}) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-display: swap;
    font-weight: 600;
    src: 
      local('Inter SemiBold'), 
      local('Inter-SemiBold'), 
      url(${Inter_SemiBold}) format('woff2');
    unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-display: swap;
    font-weight: 600;
    src: 
      local('Inter SemiBold'), 
      local('Inter-SemiBold'), 
      url(${Inter_SemiBold}) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-display: swap;
    font-weight: 300;
    src: 
      local('Inter Light'),
      local('Inter-Light'),
      url(${Inter_Light}) format('woff2');
    unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-display: swap;
    font-weight: 300;
    src: 
      local('Inter Light'),
      local('Inter-Light'),
      url(${Inter_Light}) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-display: swap;
    font-weight: 500;
    src: 
      local('Inter Medium'),
      local('Inter-Medium'),
      url(${Inter_Medium}) format('woff2');
    unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-display: swap;
    font-weight: 500;
    src: 
      local('Inter Medium'),
      local('Inter-Medium'),
      url(${Inter_Medium}) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
`;
const Theme_fonts = fonts;
export default Theme_fonts;
